import { withInstall } from '../utils/type';
import StreamLayout from './steam-layout';
export default withInstall(StreamLayout);